import { Policies } from '@/enums/apiEnums.ts';
import { useProfileStore } from '@/store/useProfileStore.ts';

const usePolicy = () => {
  const { aboutMe } = useProfileStore();

  const userPolicy = `${aboutMe?.profile?.state}/${aboutMe?.profile?.state_reason}`;

  return {
    isOnboarding: userPolicy === Policies.onboarding,
    isBeingVerified: userPolicy === Policies.beingVerified,
    isInsufficientData: userPolicy === Policies.insufficientData,
    isFailedVerification: userPolicy === Policies.failedVerification,
    isIncognitoMode: userPolicy === Policies.incognitoMode,
    isBanned: aboutMe?.profile?.state === Policies.banned,
    isHidden: aboutMe?.profile?.state === Policies.hidden,
    isActive: aboutMe?.profile?.state === Policies.active,
    isDeleted: Policies.deleted === userPolicy
  };
};

export default usePolicy;
